export default {"src":"/_next/static/media/finbox_icon.a070ecfa.svg","height":249,"width":252,"blurWidth":0,"blurHeight":0};